export enum ErrorMessages {
  MISSING_METAMASK = "Provider not set or invalid",
  INVALID_ADDRESS_ERROR = "invalid address",
  INVALID_ADDRESS_OUTPUT = "The provided payment address is not valid",
  GENERIC = "There's been a problem with your payment",
}
